import { NotificationPanel } from "@/components/NotificationPanel";
import { useAuthStore } from "@/stores/auth.store";
import { useUiStore } from "@/stores/ui.store";
import { ChevronDown, LogOut, Menu } from "lucide-react";
import { useState } from "react";

export function Header() {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isNotifOpen, setIsNotifOpen] = useState(false);
  const { user, logout } = useAuthStore();
  const { currentModule, toggleMobileSidebar } = useUiStore();

  const handleLogout = () => {
    logout();
    setIsUserMenuOpen(false);
  };

  return (
    <header className="bg-white border-b border-zinc-200 h-16 flex items-center justify-between px-4 sm:px-6">
      {/* Left: Hamburger + Module Name */}
      <div className="flex items-center gap-3">
        <button
          onClick={toggleMobileSidebar}
          className="lg:hidden p-2 -ml-2 rounded-lg text-zinc-600 hover:bg-zinc-100 transition-colors"
          aria-label="Open menu"
        >
          <Menu className="w-5 h-5" />
        </button>
        <div className="flex items-center gap-2">
          <h1 className="text-lg font-bold text-zinc-900 tracking-tight">{currentModule}</h1>
        </div>
      </div>

      {/* Right: Notifications & User Menu */}
      <div className="flex items-center gap-3 sm:gap-4">
        {/* Notification Panel */}
        <NotificationPanel
          isOpen={isNotifOpen}
          onToggle={() => {
            setIsNotifOpen(!isNotifOpen);
            setIsUserMenuOpen(false);
          }}
        />

        {/* User Dropdown */}
        <div className="relative">
          <button
            onClick={() => {
              setIsUserMenuOpen(!isUserMenuOpen);
              setIsNotifOpen(false);
            }}
            className="flex items-center gap-2.5 px-2.5 py-1.5 rounded-lg hover:bg-zinc-100/80 transition-all border border-transparent hover:border-zinc-200"
          >
            {user?.avatarUrl ? (
              <img
                src={user.avatarUrl}
                alt={user.fullName}
                className="w-8 h-8 rounded-full object-cover ring-2 ring-blue-500/20"
              />
            ) : (
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white text-sm font-bold shadow-sm">
                {user?.fullName?.charAt(0).toUpperCase() || "U"}
              </div>
            )}
            <div className="hidden sm:flex flex-col items-start leading-tight">
              <span className="text-sm font-semibold text-zinc-900">
                {user?.fullName || "User"}
              </span>
              {user?.role && (
                <span className="text-[11px] font-medium text-zinc-500 capitalize">
                  {user.role}
                </span>
              )}
            </div>
            <ChevronDown className="hidden sm:block w-3.5 h-3.5 text-zinc-400" />
          </button>

          {/* Dropdown Menu */}
          {isUserMenuOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-zinc-200 z-50">
              <div className="px-4 py-3 border-b border-zinc-200">
                <p className="text-sm font-medium text-zinc-900">{user?.fullName}</p>
                <p className="text-xs text-zinc-500">{user?.email}</p>
              </div>
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-2 px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
              >
                <LogOut className="w-4 h-4" />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
